export default __webpack_public_path__ + "static/media/Letters2_22.fd77d551.png";